/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "10.0.0";
